import styled from 'styled-components';

export const CardTitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1f2937;
  color: #ffffff;
  padding: 16px 0;
  border-radius: 8px 8px 0 0;
`;

export const CardTitle = styled.h2`
  font-size: 24px;
  font-weight: 900;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin: 0;
`;

export const TitleTag = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 16px;
  margin-top: 40px;
  margin-bottom: 16px;
  background-color: #f3f4f6;
  border-left: 6px solid #ffbb00;
  border-radius: 0 4px 4px 0;

  span {
    font-size: 18px;
    font-weight: 700;
    color: #374151;
    text-transform: uppercase;
  }

  p {
    text-transform: none;
  }
`;
